import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/login-activate-guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' }, // Cambia la ruta raíz a 'dashboard'
  { path: 'landing', loadChildren: () => import('./features/landing/landing.module').then(m => m.LandingModule), canActivate:[AuthGuard] },
  { path: 'login', loadChildren: () => import('./features/auth/components/login/login.module').then(m => m.LoginModule) },
  { path: 'register', loadChildren: () => import('./features/auth/components/register/register.module').then(m => m.RegisterModule) },
  { path: 'activate/:username', loadChildren: () => import('./features/auth/components/activate/activate.module').then(m => m.ActivateModule) },
  { path: 'home', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) },
  { path: 'recover-password', loadChildren: () => import('./features/auth/components/recover-password/recover-password.module').then(m => m.RecoverPasswordModule) },
  { path: 'activate-password', loadChildren: () => import('./features/auth/components/activate-password/activate-password.module').then(m => m.ActivatePasswordModule) },
  { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate:[AuthGuard] }, // Nueva ruta para el dashboard
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
